import { render } from "./LanguageIcons.vue?vue&type=template&id=f9d50d92&scoped=true"
import script from "./LanguageIcons.vue?vue&type=script&lang=ts"
export * from "./LanguageIcons.vue?vue&type=script&lang=ts"

import "./LanguageIcons.vue?vue&type=style&index=0&id=f9d50d92&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-f9d50d92"

export default script